import { render } from "./PurchasesPage.vue?vue&type=template&id=478d3f91"
import script from "./PurchasesPage.vue?vue&type=script&lang=js"
export * from "./PurchasesPage.vue?vue&type=script&lang=js"

import "./PurchasesPage.vue?vue&type=style&index=0&id=478d3f91&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__